/**
 * 結果ステータス（詳細）
 */
const DetailResultStatusCode = {
  /** 正常終了 */
  SUCCESS: 0,

  /** 正常終了(メッセージあり) */
  SUCCESS_MESSAGE: 1,

  /** 必須パラメーターエラー */
  PARAMETER_ERROR: -1,

  /** メールアドレス重複エラー */
  DUPLICATE_EMAIL_ERROR: -11,

  /** 禁止ドメインエラー */
  BAN_DOMAIN_ERROR: -12,

  /** サプライヤ重複エラー. */
  DUPLICATE_SUPPLIER_ERROR: -13,

  /** メールアドレス未登録エラー */
  NOT_EMAIL_EXIST_ERROR: -14,

  /** 添付ファイルサイズオーバーエラー */
  CAPACITY_OVER_ERROR: -15,

  /** 添付ファイル存在しないエラー */
  FILE_NOT_EXIST_ERROR: -16,

  /** 添付ファイル保存失敗エラー */
  FAILED_SAVE_DATA_ERROR: -17,

  /** 日付形式不正エラー */
  DATE_FORMAT_ERROR: -18,

  /** テンプレートが存在しないエラー */
  TEMPLATE_NOT_EXIST_ERROR: -19,

  /** IDNUMBERが存在しないエラー */
  IDNUMBER_NOT_EXIST_ERROR: -20,

  /** ユーザー未登録エラー */
  USER_NOT_EXIST_ERROR: -21,

  /** システム取込項目名重複エラー */
  DUPLICATE_SYSTEM_NAME_ERROR: -22,

  /** SDFileが存在しないエラー */
  SDF_NOT_EXIST_ERROR: -23,

  /** 基準納期重複エラー. */
  DUPLICATE_DELIVERY_TIME_ERROR: -24,

  /** ファイル形式エラー. */
  FILE_FORMAT_ERROR: -25,

  /** 得意先重複エラー. */
  DUPLICATE_CUSTOMER_ERROR: -27,

  /** 取り扱い不可商品エラー */
  PRODUCTS_NOT_AVAILABLE_ERROR: -28,

  /** 商品存在エラー */
  NOT_MOL_ERROR: -29,

  /** 商品上限値超過エラー */
  MAX_MOL_ERROR: -30,

  /** 商品登録済エラー */
  CHECK_MOL_ERROR: -31,

  /** ATTO ID取得エラー */
  CHECK_ATTOID_ERROR: -32,

  /** 抽出データ不整合. */
  SELECT_DATA_MISMATCH: -51,

  /** タイムアウトエラー */
  STATEMENT_TIMEOUT: -52,

  /** 登録エラー */
  INSERT_ERROR: -61,

  /** 削除エラー */
  DELETE_ERROR: -62,

  /** 更新エラー */
  UPDATE_ERROR: -63,

  /** システムエラー */
  SYSTEM_ERROR: -99,
} as const;

type DetailResultStatusCode = typeof DetailResultStatusCode[keyof typeof DetailResultStatusCode];
export default DetailResultStatusCode;
